import React from 'react';

//Third party packages
import { Row, Col, Card } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';

const PriceCompareSearchSkeleton = () => (
  <>
    <Row className="mt-5 desktop-skeleton">
      <Col>
        <Card className="p-2">
          <Skeleton count={1} height={150} />
        </Card>
      </Col>
    </Row>
    <Row className="mt-3 desktop-skeleton">
      <Col>
        <Card className="p-2">
          <Skeleton count={1} height={150} />
        </Card>
      </Col>
    </Row>
  </>
);

export default PriceCompareSearchSkeleton;
